import * as angular from 'angular';
import * as _ from 'lodash';
import {DefectType} from "../../models/defectType";
import {apsEnums} from "../../shared/dto/aps.enums";
import {States} from "../../shared/config/constant.module";
import template from './defectTypes.tpl.html';
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import ViewDefectTypeName, {openViewDefectType} from "./viewDefectType.controller";

let requires = [LoaderServiceName, DefectTypeServiceName, ViewDefectTypeName];

interface ViewDefectTypesController {
  defectTypes: DefectType[];
  viewDefectType(defectType: DefectType): void;
  getSeverityName(severity: apsEnums.Severity): string;
  exportToCsv(): void;
  sortBy: string;
}

function getSeverityName(severity: apsEnums.Severity): string {
  return apsEnums.Severity[severity];
}

export default angular.module('aps.controller.viewDefectTypes', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.VIEW_DEFECT_TYPES,
      url: '/defectTypes',
      controller: 'ViewDefectTypesCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Defect Types'
      }
    });
  })
  .controller('ViewDefectTypesCtrl', viewDefectTypesCtrl)
  .name;

function viewDefectTypesCtrl(
  $modal: mm.foundation.modal,
  loaderService: LoaderService,
  defectTypeService: DefectTypeService
): ViewDefectTypesController {
  let vm = {} as ViewDefectTypesController;
  vm.sortBy = 'name';

  loaderService.loadingPromise(defectTypeService
    .getDefectTypesAndClassifications().then(data => {
      vm.defectTypes = data.types;
    }));

  let wcPromise = defectTypeService.getDefectTypeWareClasses();

  function viewDefectType(defectType: DefectType): void {
    loaderService.loadingPromise(wcPromise.then(wareClasses => {
      return defectTypeService.getDefectTypeDetails(defectType.id).then(detail => {
        openViewDefectType({
          defectType: detail,
          wareClasses: wareClasses
        }, $modal);
      });
    }));
  }

  vm.viewDefectType = viewDefectType;
  vm.getSeverityName = getSeverityName;

  vm.exportToCsv = function() { 
    return _.orderBy(_.map<DefectType, any>(this.defectTypes, (x) => {
      return {
        legacyId: x.legacyId,
        abbreviation: x.abbreviation,
        name: x.name,
        severity: this.getSeverityName(x.severity),
        location: x.defectClassificationName,
        defaultSampleSize: x.defaultInspectionSampleSize,
        description: x.description       
      };
    }), [vm.sortBy], ['asc']);
  }

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectTypes/defectTypes.controller.ts